module.exports = __webpack_public_path__ + "img/paper2.f9d0c858.png";